import { allRota,selfRota } from '@/assets/js/api/rota'

const user = {
  state: {
    allRota:[],
    selfRota:[]
  },
  actions: {
    GetAllRota ({ commit }) {
      return new Promise((resolve, reject) => {
        allRota().then(response => {
          if(response.data.result){
            commit('SET_ALL_ROTA', response.data.data)
          }
          resolve(response.data.result)
        })
      })
    },
    GetSelfRota ({ commit }) {
      return new Promise((resolve, reject) => {
        selfRota().then(response => {
          if(response.data.result){
            commit('SET_SELF_ROTA', response.data.data)
          }
          resolve(response.data.result)
        })
      })
    }
  },
  mutations: {
    SET_ALL_ROTA (state, data) {
      state.allRota = data
    },
    SET_SELF_ROTA(state, data) {
      state.selfRota = data
    }
  },
  namespaced: true
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/rota.js